import { useEffect, useState } from "react";
import formatTime from "../../utils/formatTime";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import useTranslationSetup from "../../utils/useTranslationSetup";
import MicIcon from "@mui/icons-material/Mic";
import "./styles.css";

const CustomAudioRecorder = ({
  isRecording,
  isStopped,
  audioBlob,
  buttonText,
  activity,
  setDuration,
  loading = false,
  dataLoading = false,
  onClick,
}) => {
  const { activeLanguage } = useTranslationSetup();
  const [pointerEvents, setPointerEvents] = useState("auto");
  const [time, setTime] = useState(0);
  let currInterval = 0;

  const variant =
    activity === "practice"
      ? audioBlob === null
        ? "outlined"
        : "contained"
      : isRecording
        ? "outlined"
        : "contained";

  const disabled = (audioBlob !== null && isStopped) || loading;

  const className =
    activity === "practice"
      ? `practice-audio-recorder-button ${audioBlob !== null ? "practice-audio-recorder-stop" : ""}`
      : `custom-ff-regular ${isRecording ? "assessment-audio-recording" : audioBlob !== null || disabled ? "assessment-audio-recorder-stop" : "assessment-audio-recorder-button pulsing-button"}`;

  useEffect(() => {
    if (activity !== "practice" && isRecording) {
      currInterval = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    }
    return () => {
      if (activity !== "practice") {
        clearInterval(currInterval);
      }
    };
  }, [activity, isRecording]);

  useEffect(() => {
    if (activity !== "practice" && time !== 0) {
      setDuration(time);
    }
  }, [activity, time]);

  useEffect(() => {
    if (activity === "practice" && isRecording) {
      setPointerEvents("none");
      setTimeout(() => {
        setPointerEvents("auto");
      }, 800);
    }
  }, [isRecording, activity]);

  useEffect(() => {
    if (activity !== "practice" && audioBlob === null) {
      setTime(0);
    }
  }, [audioBlob, activity]);

  return (
    <>
      {activity !== "practice" &&
        (isRecording || (isStopped && audioBlob !== null)) && (
          <Box className="audio-recorder-timer-wrapper">
            <Box
              className={`practice-red-dot ${!isRecording && isStopped ? "practice-red-dot-stable" : ""}`}
            />
            <Typography lang={activeLanguage} className="audio-recorder-timer">
              {formatTime(time)}
            </Typography>
          </Box>
        )}
      <Button
        variant={variant}
        sx={{ pointerEvents }}
        endIcon={
          activity === "practice" &&
          (isRecording
            ? !loading && <Box className="practice-red-dot" />
            : audioBlob === null &&
              !loading && <MicIcon className="practice-mic-icon" />)
        }
        disableElevation
        disabled={disabled}
        className={className}
        lang={activeLanguage}
        onClick={onClick}
      >
        {loading ? (
          <CircularProgress
            className={dataLoading ? "button-loader" : "recorder-button-loader"}
          />
        ) : (
          buttonText
        )}
      </Button>
    </>
  );
};

export default CustomAudioRecorder;
